exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-day-grid-event,.fc-event,.fc-event-draggable,.fc-event-resizable,.fc-list-item,.fc-time-grid-event{cursor:pointer!important}", ""]);

// exports
